/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import * as ProfilePages from './ProfilePages';
import { PersonalInfo } from '../ProfileOPL/PersonalInfo/PersonalInfo';
import { Income } from '../ProfileOPL/Income/Income';
import { Expenses } from '../ProfileOPL/Expenses/Expenses';
import RiskTolerance from './RiskTolerance/RiskTolerance';
import { Taxes } from '../ProfileOPL/Taxes/Taxes';
import { Insurance } from '../ProfileOPL/Insurance/Insurance';
import { OtherAssets } from '../ProfileOPL/OtherAssets/OtherAssets';
import { Goals } from '../ProfileOPL/Goals/Goals';
import { Accounts } from './Accounts/Accounts';
import { StockOptions } from '../ProfileOPL/StockOptions/StockOptions';

export default class ProfileView extends Component {
  constructor(props) {
    super(props);
    const { initializeSection, clientId, page, pivotId, stepId } = this.props;

    initializeSection(clientId, ADV.util.env('isAdviserArea'), page, pivotId, stepId);
  }

  componentDidMount() {
    this.setDocumentTitle();
  }

  shouldComponentUpdate() {
    const isOnProfile = window.location.hash.indexOf('profile/') > -1;
    const isOnWorkFlow = window.location.hash.indexOf('workflow/') > -1;
    return isOnProfile || isOnWorkFlow;
  }

  setDocumentTitle() {
    const { page, portalName, isHiddenLeversRTQ } = this.props;

    switch (page) {
      case ProfilePages.PERSONAL_INFO:
        document.title = `Profile - Personal Info | ${portalName}`;
        break;
      case ProfilePages.INCOME:
        document.title = `Profile - Income | ${portalName}`;
        break;
      case ProfilePages.EXPENSES:
        document.title = `Profile - Expenses | ${portalName}`;
        break;
      case ProfilePages.INSURANCE:
        document.title = `Profile - Insurance | ${portalName}`;
        break;
      case ProfilePages.RISK_TOLERANCE:
        document.title = `Profile - ${
          isHiddenLeversRTQ ? 'Risk Profile' : 'Risk Tolerance'
        } | ${portalName}`;
        break;
      case ProfilePages.TAX_FILING:
        document.title = `Profile - Taxes | ${portalName}`;
        break;
      case ProfilePages.GOALS:
        document.title = `Profile - Goals Input | ${portalName}`;
        break;
      case ProfilePages.OTHER_ASSETS:
        document.title = `Profile - Other Assets | ${portalName}`;
        break;
      case ProfilePages.ACCOUNTS_REACT:
        document.title = `Profile - Accounts | ${portalName}`;
        break;
      case ProfilePages.STOCK_OPTIONS:
        document.title = `Profile - Equity Compensation | ${portalName}`;
        break;
      default:
        document.title = `Profile | ${portalName}`;
        break;
    }
  }

  render() {
    const { page, clientId, workflowProps, ...rest } = this.props;
    let renderedSubsection;

    switch (page) {
      case ProfilePages.PERSONAL_INFO:
        renderedSubsection = (
          <PersonalInfo workflowProps={workflowProps} clientId={clientId} key={`pi_${clientId}`} />
        );
        break;
      case ProfilePages.INCOME:
        renderedSubsection = (
          <Income workflowProps={workflowProps} clientId={clientId} key={`pi_${clientId}`} />
        );
        break;
      case ProfilePages.EXPENSES:
        renderedSubsection = (
          <Expenses workflowProps={workflowProps} clientId={clientId} key={`ex_${clientId}`} />
        );
        break;
      case ProfilePages.INSURANCE:
        renderedSubsection = (
          <Insurance workflowProps={workflowProps} clientId={clientId} key={`in_${clientId}`} />
        );
        break;
      case ProfilePages.RISK_TOLERANCE:
        renderedSubsection = (
          <RiskTolerance workflowProps={workflowProps} clientId={clientId} key={`rt_${clientId}`} />
        );
        break;

      case ProfilePages.TAX_FILING:
        renderedSubsection = (
          <Taxes workflowProps={workflowProps} clientId={clientId} key={`tf_${clientId}`} />
        );
        break;
      case ProfilePages.GOALS:
        renderedSubsection = (
          <Goals workflowProps={workflowProps} clientId={clientId} key={`gl_${clientId}`} />
        );
        break;
      case ProfilePages.OTHER_ASSETS:
        renderedSubsection = (
          <OtherAssets workflowProps={workflowProps} clientId={clientId} key={`oa_${clientId}`} />
        );
        break;
      case ProfilePages.STOCK_OPTIONS:
        renderedSubsection = (
          <StockOptions workflowProps={workflowProps} clientId={clientId} key={`so_${clientId}`} />
        );
        break;
      case ProfilePages.ACCOUNTS_REACT:
        renderedSubsection = (
          <Accounts
            workflowProps={workflowProps}
            clientId={clientId}
            key={`ar_${clientId}`}
            {...rest}
          />
        );
        break;
      default:
        break;
    }

    return <div id="Profile">{renderedSubsection}</div>;
  }
}
